import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import{AddNewPolicyMdl} from '../../Models/AddNewPolicy';
import{InsuredMdl} from '../../Models/InsuredMdl';

@Component({
  selector: 'Register',
  templateUrl: './Register.html',
  styleUrls: ['./Register.css']
})
export class Register {
  public AddNewPolicyObj:AddNewPolicyMdl=new AddNewPolicyMdl();
  public RegObj:InsuredMdl=new InsuredMdl();
   public License:boolean;
   public OTP:boolean;
   public Vehicle:boolean;
   public Count:number=1;
   public Motor:boolean;
   public SelectedType:string;
  public PolicyTrue:boolean;
  public DobRequired:boolean;
constructor(private router: Router){
this.AddNewPolicyObj.PolicyType="5515";
//this.AddNewPolicyObj.VehicleDefionitionType="2";
}
 
ValidateIqama(evt:any){
  if(this.RegObj.IqamaNo.length>0){
    if(evt.target.value.charAt(0)=="1"){
      this.DobRequired=true;
        }
        else{
          this.DobRequired=false;
        }
  }
  else{
    alert("Please enter Iqama No")
  }
 
}

Next(){
    this.Count++;
    if(this.Count==2){
this.OTP=true;
this.License=false;
    }
    else if(this.Count==3){
      this.OTP=false;
     // this.PolicyTrue=true;
      this.router.navigate(['./PolicyDashboard/Policy']);
    }
  

  }

  checked(Event:any) {
    if (Event.target.checked) {
        this.AddNewPolicyObj.Transfer = true;
    }
    else {
        this.AddNewPolicyObj.Transfer = false;
    }
  }
  Back(){
    this.Motor=false;
  }

  Proceed(){

  }
  Motors(){
    this.Motor=true;
    this.SelectedType="Motor TPL";
  }
  Comprehensive(){
    this.Motor=true;
    this.SelectedType="Motor Comprehensive";
  }
  Medical(){
    this.Motor=true;
    this.SelectedType="Medical Insurance";
  }
 
  Dashboard(){
this.router.navigate(['./Master/PolicyDashboard']);
  }
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Register/Register.ts